/* istanbul ignore */
/* eslint-disable import/prefer-default-export */
export { default as ListingCardWithFragment } from './current-listing-card-with-fragment';
